export const types = {
  SET_EDITOR: 'SET_EDITOR',
};
